import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Search, Wind, Leaf, ShieldAlert } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Search className="text-holistic-sage" size={32} data-id="element-19" />,
    title: 'Descodificar tus síntomas',
    description: 'Entender qué te está queriendo decir tu cuerpo con cada dolor o malestar recurrente.'
  }, {
    icon: <Wind className="text-holistic-sage" size={32} data-id="element-20" />,
    title: 'Liberación Celular',
    description: 'Ejercicios prácticos para soltar el estrés acumulado de años que te mantiene en alerta.'
  }, {
    icon: <Leaf className="text-holistic-sage" size={32} data-id="element-21" />,
    title: 'Alimentación Vibracional',
    description: 'Recetas específicas que preparan tu terreno biológico para la cura y desinflamación.'
  }, {
    icon: <ShieldAlert className="text-holistic-sage" size={32} data-id="element-22" />,
    title: 'Paz Mental',
    description: 'Herramientas de emergencia para frenar la ansiedad y el pánico en menos de 5 minutos.'
  }];
  return <section className="py-24 bg-holistic-sand/30" data-id="element-23">
      <div className="max-w-6xl mx-auto px-6" data-id="element-24">
        <FadeIn data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-serif text-holistic-earth mb-4" data-id="element-27">
              ¿Qué vas a lograr con este programa?
            </h2>
            <div className="w-24 h-1 bg-holistic-gold mx-auto rounded-full" data-id="element-28"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-29">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.15} direction="up" data-id="element-30">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-holistic-sand hover:shadow-md transition-shadow h-full flex flex-col md:flex-row gap-6 items-start" data-id="element-31">
                <div className="bg-holistic-cream p-4 rounded-2xl shrink-0" data-id="element-32">
                  {benefit.icon}
                </div>
                <div data-id="element-33">
                  <h3 className="text-xl font-bold text-holistic-earth mb-3 flex items-center gap-2" data-id="element-34">
                    <span className="text-holistic-gold" data-id="element-35">✅</span>{' '}
                    {benefit.title}
                  </h3>
                  <p className="text-holistic-earth-light leading-relaxed" data-id="element-36">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}